import { useEffect, useState } from "react";
import PBtn from "../common/PBtn";

export default function StickyLabCTA({ go }) {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const h = () => setShow(window.scrollY > 320);
    window.addEventListener("scroll", h, { passive: true });
    return () => window.removeEventListener("scroll", h);
  }, []);
  if (!show) return null;
  return (
    <div style={{ position: "fixed", top: 0, left: 0, right: 0, zIndex: 98, background: "linear-gradient(90deg,#0f2344,#1A3C6E)", padding: "8px 20px", display: "flex", alignItems: "center", justifyContent: "space-between", boxShadow: "0 3px 12px rgba(0,0,0,.2)", animation: "slidein .25s ease" }}>
      <div style={{ color: "rgba(255,255,255,.85)", fontSize: 13 }}>🔬 <strong style={{ color: "#fff" }}>Looking for GC lab instruments?</strong> Browse 34+ products compatible with Shimadzu, Agilent and more.</div>
      <div style={{ display: "flex", gap: 8, flexShrink: 0 }}>
        <PBtn onClick={() => go("contact")} extra={{ padding: "7px 16px", fontSize: 12 }}>Get Bulk Quote</PBtn>
        <button onClick={() => setShow(false)} style={{ background: "rgba(255,255,255,.1)", border: "1px solid rgba(255,255,255,.2)", color: "rgba(255,255,255,.7)", width: 28, height: 28, borderRadius: "50%", cursor: "pointer", fontSize: 13, display: "flex", alignItems: "center", justifyContent: "center" }}>x</button>
      </div>
    </div>
  );
}
